
import React, { useEffect, useRef, useState } from 'react'

import styles from './stat.module.sass'

function Stat(props) {
	const ref = useRef()
	const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
	const numbers = '0123456789'
	const [counters, setCounters] = useState([])
	const stat = props.value.split('')
	const animate = props.animate

	//function to accept string and determine type of character whether its a number, letter or special character
	function getCharacters(string) {
		if (string === '$' || string === '+' || string === '/' || string === '-' || string === '%' || string === '.' || string === '~' || string === '>' || string === '<' || string === ',' || string === ' ') {
			return string
		} else if (string.match(/[a-z]/i)) {
			return letters
		} else if (string.match(/[0-9]/i)) {
			return numbers
		}
	}
  
	useEffect(() => {
		if (!ref.current) return

		function startCounting() {
			const allCounters = ref.current.querySelectorAll(`.${styles.counter} > span`)
			setCounters(allCounters)
		
			function animateCounter(el, duration) {
				const string = getCharacters(el.getAttribute('data-final'))
				const interval = setInterval(() => {
				el.innerText = string.charAt(Math.random() * string.length)
				duration = duration - 50
				if (duration <= 0) {
					clearInterval(interval)
					el.innerText = el.getAttribute('data-final')
				}
				}, 50)
			}
		
			allCounters.forEach((el, index) => {
				const duration = 1000
				animateCounter(el, duration)
			})
		}
	
		const observer = new IntersectionObserver(
		  (entries) => {
			entries.forEach((entry) => {
			  if (entry.isIntersecting) {
				startCounting()
				observer.unobserve(ref.current)
			  }
			})
		  },
		  { threshold: 0.1 }
		);
	
		observer.observe(ref.current)
	
		return () => {
		  observer.unobserve(ref.current)
		}
  
	}, [ref])

	useEffect(() => {
		function startCounting() {
			const allCounters = ref.current.querySelectorAll(`.${styles.counter} > span`)
			setCounters(allCounters)
		
			function animateCounter(el, duration) {
				const string = getCharacters(el.getAttribute('data-final'))
				const interval = setInterval(() => {
				el.innerText = string.charAt(Math.random() * string.length)
				duration = duration - 50
				if (duration <= 0) {
					clearInterval(interval)
					el.innerText = el.getAttribute('data-final')
				}
				}, 50)
			}
		
			allCounters.forEach((el, index) => {
				const duration = 1000
				animateCounter(el, duration)
			})
		}

		if(animate == true){
			startCounting()
		}
	}, [animate])
  
	return (
	  <div ref={ref} title={props.value} className={styles.stat}>
		{stat.map((el, index) => (
		  <div className={styles.counter} key={index}>
			<span data-final={stat[index]}></span>
		  </div>
		))}
	  </div>
	);
  }

export default Stat